import styled from "styled-components";
import SubHeaderBase from "./SubHeader";

const SubHeaderWithLinks = styled(SubHeaderBase)`
  a {
    color: var(--primary);
    text-decoration: underline;
    font-size: inherit;
    cursor: pointer;
    pointer-events: auto;
    position: relative;
    z-index: 2;
    display: inline;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    &:active {
      opacity: 0.6;
    }
  }
`;

export default SubHeaderWithLinks;
